import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ArticleCard, VoiceCard } from '../shared/iris.interface';
import { IrisService } from '../shared/iris.service';
import { Observable, Subscription } from 'rxjs';
import { MatSpinner } from '@angular/material/progress-spinner';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

@Component({
  selector: 'app-voice-article',
  templateUrl: './voice-article.component.html',
  styleUrls: ['./voice-article.component.scss']
})
export class VoiceArticleComponent implements OnInit, OnDestroy {
  key: string;
  gobackBtnLabel = "navigation.goback";
  card: VoiceCard;
  subsc: Subscription;

  overlayRef = this.overlay.create({
    hasBackdrop: true,
    positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private location: Location,
    private irisSrv: IrisService,
    private overlay: Overlay,
  ) {
    console.log('voice-article constructor');
    this.overlayRef.attach(new ComponentPortal(MatSpinner));
    this.route.queryParams.subscribe(params => {
      this.key = params['key'];
      this.irisSrv.getVoiceArticle(this.key)
        .then(voice => {
          this.card = Object.assign({}, voice);
          this.card.contents = this.card.contents.replace('\\n', '\n');
          while(this.card.contents.includes('\\n')) {
            this.card.contents = this.card.contents.replace('\\n', '\n');
          }
        })
        .finally(() => {
          this.overlayRef.detach();
        });
      });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {

  }

  chipStyle(type: string) {
    switch(type) {
    case 'search.type_info':
      return {
        'background-color': '#f8ca6a',
        'color': 'white'
      };
    case 'search.type_voice':
      return {
        'background-color': '#8cd6ef',
        'color': 'white'
      };
    case 'search.type_knowledge':
      return {
        'background-color': '#7ee269',
        'color': 'white'
      };
    default:
      return {
        'background-color': '#7ee269',
        'color': 'white'
      };
    } 
  }

  public goBack() {
    this.location.back();
  }
}
